module.exports = __webpack_public_path__ + "img/briefcase.ff98715e.svg";